// import { useState } from "react";
import { Link } from "react-router-dom";

import edit from "../../images/edit.png";
import style from "../../styles/grid.module.css";
import { GetCompania } from "../../actions/compania";

// localStorage.setItem("token","alta");
// localStorage.setItem("refreshToken", 'alta');
// localStorage.setItem("user", 'admin');

export default function Compania() {
   const ciadata =  GetCompania()
   
   // function handleInputChange(e) {
   //    if (e.key === "Enter") {
   //       // dispatch(getClientesByName(usr, nombre));
   //       console.log('clientes: ', nombre);
   //       setName("");
   //    }
   // }
   // let busco = ["message",data]
   // console.log('data: ',data, busco.includes(data,0));
   // if (busco.includes(data,0)) {
   //    window.location.href = '/login'
   // }
   console.log('ciadata: ', ciadata);
   return (

       <div className={style.tableCli}>
   <div>
      <div className={style.header}>
         <div className={style.gridTitle}>
            <h2>Companias</h2>
         </div>
         <div>
            <Link
               to={"/formCia"}
               className="dLink"
               title="Alta Compania"
               state={{
                   id:  0,
                   razsoc:  "",
                   email:"",
                   movil: "",
                   fijo: "",
                   cod_status:1,                   
                }}
                >
               {" "}
               <button className={style.inputBtnNew}>Alta Compania</button>
            </Link>
            &nbsp;&nbsp;
         </div>
      </div>
   </div>
   <br />
   <div>
      <table className={style.gridTable}>
         <thead>
            <tr  className={style.trTitle}>
               <th className={style.title}>ID</th>
               <th className={style.title}>Nombre</th>
               <th className={style.title2}>E-Mail</th>
               <th className={style.title2}>Telefono</th>
               <th>Acciones</th>
            </tr>
         </thead>
         <tbody>
            {ciadata?.length>0 &&
               ciadata?.map((cia,i) => {
                   return (
                     <tr key={i} className={style.trdatos}>
                        <td className={style.style_td}>{cia.id}</td>
                        <td className={style.style_td}>{cia.razsoc}</td>
                        <td className={style.style_email}>
                           {cia.email}
                        </td>
                        <td className={style.style_email}>
                           {cia.movil}
                        </td>
                        <td className={style.dLink}>
                           <Link
                              to={"/formCia"}
                              state={{
                                  id:  cia.id,
                                  code: cia.code,
                                  razsoc:  cia.razsoc,
                                  email: cia.email,
                                  movil: cia.movil,
                                  fijo: cia.fijo,
                                  cod_status:1,                 
                                }}
                                >
                              <img src={edit} height="30px" alt="" />
                              {/* <FcAcceptDatabase style={estilo} />  */}
                           </Link>
                           &nbsp;&nbsp;
                        </td>
                     </tr>
                  );
                })}
         </tbody>
      </table>
   </div>
</div>
);
}

